import { ViewSimpleSelect } from "../view/view-simple-select";
import { InteractionState } from "../abstract-interaction";

export class EditorSimpleSelect extends ViewSimpleSelect {
  buildInitialState(options: any): any {
    return {
      ...super.buildInitialState(options),
      useOutlineSelect: false,
    };
  }

  isManualInputSupported(state: InteractionState): boolean {
    return false;
  }
}
